import { Row, Col, Form, Stack, Button } from "react-bootstrap"
import Label from "./Label"
import { ReactComponent as EditIcon } from "../svgs/edit.svg"
import { ReactComponent as CheckIcon } from "../svgs/check.svg"
import { ReactComponent as CancelIcon } from "../svgs/stop.svg"
import { ReactComponent as DeleteIcon } from "../svgs/delete.svg"
import React, { useState, useEffect } from "react"
import Loading from "./Loading"
import useUXStore from "../api/ux/store"

const MD:any = 2
export const EditableLabel = ({md=MD, label="sample",value="sample",edit=false, onChanged=(val:any)=> {}}) => {
    return <Row >
        <Col md={md} style={{padding:"0px 10px 0px 0px"}}><Label padding="0" textAlign="right" color="gray" fontWeight="400" size="medium">{label}</Label></Col>
        <Col>
            {!edit && <Label padding="0" textAlign="left">{value}</Label>}
            {edit && <Form.Control style={{height:"27px"}} defaultValue={value} onChange={(e) => onChanged(e.currentTarget.value)}/>}
        </Col>
    </Row>
}

export const EditableName = ({md=MD, label="sample",fname="",lname="",edit=false, onChangedFname=(val:any)=> {}, onChangedLname=(val:any)=> {}}) => {
    return <Row >
        <Col md={md} style={{padding:"0px 10px 0px 0px"}}><Label padding="0" textAlign="right" color="gray" fontWeight="400" size="medium">{label}</Label></Col>
        <Col>
            {!edit && <Label padding="0" textAlign="left">{fname + " " + lname}</Label>}
            {edit && <Form.Control style={{height:"27px"}} placeholder="Firstname" defaultValue={fname} onChange={(e) => onChangedFname(e.currentTarget.value)}/>}
        </Col>
        {edit && <Col>
            <Form.Control style={{height:"27px"}} placeholder="Lastname" defaultValue={lname} onChange={(e) => onChangedLname(e.currentTarget.value)}/>
        </Col>}
    </Row>
}

type EditableControlProps = {
    defaultData      : any | null
    className?       : string  
    editable?        : boolean
    deletable?       : boolean 
    onApply          : (data:any)=> void
    onDelete?         : (data:any)=> void
    children         : (data:any,onChanged:(id:any,value:any)=>void,showEdit:boolean) => JSX.Element
}


const EditableControl: React.FC<EditableControlProps> = ({
    editable=true,deletable=false, onDelete,
    defaultData,onApply,children, className="control-container"}) => {
    const [edit, setEdit] = useState(false)
    const [data,setData] = useState<any | null>(defaultData)
    const {refreshDialog} = useUXStore( state => state)
    useEffect(() =>{
        if (data) return
        if (data === null && defaultData !== null)
            setData(defaultData)
    }, [])
    // was cancelled?
    if (!editable && edit) {
        setData(defaultData)
        setEdit(false)
    }

    //console.log(sessionDetails)
    if (defaultData === null) return <Loading center/>

    if (!data) setData(defaultData)

    const toggleEdit = () => {
        setEdit(!edit)
    }
    const _onDelete = () => {
        refreshDialog({
            id: "deleteData",
            content: "Are you sure you want to delete this?",
            title: "Confirm Delete",
            visible: true,
            onConfirm() {
                onDelete!(defaultData)
            },
        }, true)
    }
    const _onApply = () => {
        setEdit(false)
        onApply(data)
    }
    const onChanged = (id:string,val:string) => {
        const changed = {...data, [id]:val}
        setData(changed)
        //console.log(changed, id, val)
    }
    return <div style={{padding:"0"}} className={className}>
        {editable && !edit && <Button size="sm" variant="link" style={{float:"right"}} onClick={toggleEdit}><EditIcon stroke={"gray"}/></Button>}
        {edit && <Stack style={{float:"right"}} direction="horizontal">
            {deletable && <Button size="sm" variant="link" onClick={_onDelete}><DeleteIcon stroke="red"/></Button>}
            <Button size="sm" variant="link" onClick={toggleEdit}><CancelIcon stroke="red"/></Button>
            <Button size="sm" variant="link" onClick={_onApply}><CheckIcon stroke="green"/></Button>
        </Stack>}
        {children(data, onChanged, edit)}
    </div>
}

export default EditableControl